var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "documentValidationRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "bg-white rounded p-4" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 mb-3" }, [
            _c("em", { staticClass: "fas fa-plus text-orange mr-1" }),
            _c(
              "span",
              { staticClass: "color-gray-7 font-weight-bold font-16" },
              [_vm._v(" Anejar Determinación de Ética ")]
            )
          ]),
          _c(
            "div",
            { staticClass: "col-md-9" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-file-input", {
                          attrs: {
                            accept: ".pdf",
                            "attachment-id": _vm.document.fileId,
                            "custom-error-msg":
                              "Favor seleccionar un documento.",
                            "display-style": "normal",
                            error: errors[0],
                            name: _vm.document.filename,
                            required: ""
                          },
                          on: {
                            input: function($event) {
                              return _vm.onFileAdded($event)
                            }
                          },
                          model: {
                            value: _vm.document.file,
                            callback: function($$v) {
                              _vm.$set(_vm.document, "file", $$v)
                            },
                            expression: "document.file"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-3" },
            [
              _c(
                "action-button",
                {
                  staticClass: "float-right mr-3",
                  attrs: {
                    i: "fas fa-times-circle",
                    type: "button",
                    variant: "btn btn-outline-danger btn-cancel danger"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onCancel()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "action-button",
                {
                  staticClass: "float-right mr-3",
                  attrs: {
                    i: "fas fa-file-plus",
                    type: "button",
                    variant: "success"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onAddDocument()
                    }
                  }
                },
                [_vm._v(" Anejar ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }